"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ExternalApiErrorSeverity;

(function (ExternalApiErrorSeverity) {
  ExternalApiErrorSeverity["low"] = "low";
  ExternalApiErrorSeverity["medium"] = "medium";
  ExternalApiErrorSeverity["high"] = "high";
  ExternalApiErrorSeverity["critical"] = "critical";
})(ExternalApiErrorSeverity = exports.ExternalApiErrorSeverity || (exports.ExternalApiErrorSeverity = {}));